function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-link",
    d: "M4.532 16.125a3.72 3.72 0 0 1 3.718-3.718h4.714v-2.282H8.25a6 6 0 0 0 0 12h4.714v-2.282H8.25a3.72 3.72 0 0 1-3.718-3.718zM9.107 17.3h10.286v-2.354H9.107zm11.143-7.175h-4.714v2.282h4.714a3.718 3.718 0 1 1 0 7.436h-4.714v2.282h4.714a6 6 0 0 0 0-12z",
    transform: "translate(-2.25 -4.125)",
    style: {
      fill: "#7a8b99"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e196b5fd5989caf9f4d26c015de843ff.svg";
export { ForwardRef as ReactComponent };